export const applySectionOverrides = (section, sectionOverrides)=> {
  return {
    ...section,
    ...sectionOverrides
  };
};

export const buildInitialSectionOverrides = ()=> {
  return {};
};
